export const PRIVACY_POLICY = {
  title: "Privacy Policy",
  updated: "Ultimo aggiornamento: agosto 2026",
  intro: "La presente informativa descrive come Starting Point Agency raccoglie e tratta i dati personali degli utenti che visitano questo sito, ai sensi del Regolamento (UE) 2016/679 (\"GDPR\") e del D.Lgs. 196/2003.",
  sections: [
    {
      heading: "1. Titolare del trattamento",
      paragraphs: [
        "Il titolare del trattamento è Starting Point Agency — P.IVA IT05931300874 — Catania, Sicilia (Italia).",
        "Contatti: startpointagency@gmail.com — +39 392 355 5521.",
      ],
    },
    {
      heading: "2. Dati che raccogliamo",
      paragraphs: ["Tramite il form contatti di questo sito raccogliamo esclusivamente i dati che l'utente decide di inviarci:"],
      list: ["Nome e cognome", "Nome dell'azienda", "Indirizzo email", "Numero di telefono", "Settore di attività", "Servizio richiesto", "Budget indicativo", "Contenuto del messaggio"],
      after: "Il sito raccoglie inoltre dati tecnici di navigazione necessari al suo funzionamento.",
    },
    {
      heading: "3. Finalità e base giuridica",
      paragraphs: [
        "I dati inviati tramite il form vengono utilizzati esclusivamente per rispondere alla richiesta dell'utente, organizzare la consulenza gratuita e, se richiesto, avviare un rapporto commerciale.",
        "La base giuridica del trattamento è il consenso dell'interessato e l'esecuzione di misure precontrattuali (art. 6, par. 1, lett. a e b, GDPR).",
      ],
    },
    {
      heading: "4. Conservazione dei dati",
      paragraphs: [
        "I dati vengono conservati per il tempo necessario a gestire la richiesta e l'eventuale rapporto commerciale, e comunque non oltre quanto previsto dalla normativa vigente. L'utente può chiederne la cancellazione in qualsiasi momento.",
      ],
    },
    {
      heading: "5. Comunicazione a terzi",
      paragraphs: [
        "I dati non vengono venduti né ceduti a terzi per finalità di marketing. Possono essere trattati, per conto del titolare, da fornitori tecnici necessari al funzionamento del sito e dei servizi di comunicazione (hosting e invio di email).",
      ],
    },
    {
      heading: "6. Diritti dell'interessato",
      paragraphs: ["Ai sensi degli artt. 15–22 del GDPR, l'utente ha diritto di:"],
      list: ["accedere ai propri dati personali", "ottenere la rettifica o la cancellazione", "limitare o opporsi al trattamento", "richiedere la portabilità dei dati", "revocare il consenso in qualsiasi momento"],
      after: "È inoltre possibile proporre reclamo all'autorità di controllo: Garante per la protezione dei dati personali (www.garanteprivacy.it).",
    },
    {
      heading: "7. Come esercitare i diritti",
      paragraphs: ["Per esercitare i propri diritti è sufficiente scrivere a startpointagency@gmail.com."],
    },
    {
      heading: "8. Modifiche a questa informativa",
      paragraphs: ["Eventuali aggiornamenti di questa informativa saranno pubblicati su questa pagina con indicazione della data di revisione."],
    },
  ],
};

export const COOKIE_POLICY = {
  title: "Cookie Policy",
  updated: "Ultimo aggiornamento: agosto 2026",
  intro: "Questa pagina descrive come questo sito utilizza i cookie e tecnologie simili, ai sensi della normativa europea (direttiva ePrivacy) e delle linee guida del Garante per la protezione dei dati personali.",
  sections: [
    {
      heading: "1. Cosa sono i cookie",
      paragraphs: ["I cookie sono piccoli file di testo che i siti visitati salvano sul dispositivo dell'utente per garantire il funzionamento tecnico del sito e, in alcuni casi, raccogliere informazioni statistiche."],
    },
    {
      heading: "2. Cookie tecnici",
      paragraphs: [
        "Questo sito utilizza esclusivamente cookie tecnici, necessari al corretto funzionamento delle pagine e delle funzionalità (ad esempio la gestione della sessione di navigazione). Questi cookie non richiedono il consenso dell'utente.",
      ],
    },
    {
      heading: "3. Cookie di terze parti",
      paragraphs: [
        "Il sito può includere contenuti o strumenti forniti da terze parti (ad esempio video incorporati o strumenti di analisi aggregata del traffico) che potrebbero rilasciare propri cookie. Starting Point Agency non utilizza cookie di profilazione propri e non vende dati di navigazione a terzi.",
      ],
    },
    {
      heading: "4. Come gestire i cookie",
      paragraphs: [
        "L'utente può in qualsiasi momento disattivare o eliminare i cookie dalle impostazioni del proprio browser. La disattivazione dei cookie tecnici potrebbe compromettere alcune funzionalità del sito.",
      ],
    },
    {
      heading: "5. Aggiornamenti",
      paragraphs: ["Eventuali modifiche a questa Cookie Policy saranno pubblicate su questa pagina. Per qualsiasi domanda: startpointagency@gmail.com."],
    },
  ],
};

export const TERMINI = {
  title: "Termini e Condizioni",
  updated: "Ultimo aggiornamento: agosto 2026",
  intro: "I presenti termini regolano l'utilizzo del sito di Starting Point Agency. Navigando su questo sito, l'utente accetta le condizioni di seguito riportate.",
  sections: [
    {
      heading: "1. Oggetto",
      paragraphs: [
        "Il sito presenta i servizi di marketing e comunicazione offerti da Starting Point Agency — P.IVA IT05931300874 — Catania, Sicilia (Italia). I contenuti del sito hanno finalità informative e commerciali.",
      ],
    },
    {
      heading: "2. Proprietà intellettuale",
      paragraphs: [
        "Il marchio, il logo, i testi, le grafiche, le animazioni e tutti i contenuti originali di questo sito sono di proprietà di Starting Point Agency. I video e i materiali dei case study appartengono ai rispettivi clienti e sono pubblicati con il loro consenso. È vietata la riproduzione non autorizzata.",
      ],
    },
    {
      heading: "3. Limitazione di responsabilità",
      paragraphs: [
        "Le informazioni contenute nel sito sono fornite in buona fede e a scopo illustrativo. I risultati riportati nei case study si riferiscono a progetti specifici e non costituiscono garanzia di risultati identici per altri clienti o contesti.",
      ],
    },
    {
      heading: "4. Link esterni",
      paragraphs: [
        "Il sito contiene link a piattaforme e profili esterni (social network, siti dei clienti). Starting Point Agency non è responsabile dei contenuti di siti di terze parti.",
      ],
    },
    {
      heading: "5. Legge applicabile e foro competente",
      paragraphs: [
        "I presenti termini sono regolati dalla legge italiana. Per qualsiasi controversia è competente il foro di Catania, salvo diversa disposizione di legge.",
      ],
    },
    {
      heading: "6. Contatti",
      paragraphs: ["Per qualsiasi questione relativa a questi termini: startpointagency@gmail.com — +39 392 355 5521."],
    },
  ],
};
